<template>
  <v-data-table
    :items="contracts"
    :headers="headers"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50, -1]
    }"
    :search="search"
    :options.sync="options"
    no-results-text="No contracts match the selected filter"
    item-key="contract_number"
    class="elevation-1"
  >
    <template v-for="(col, i) in filters" v-slot:[`header.${i}`]="{ header }">
      <div style="display: inline-block; padding: 16px 0;">{{ header.text }}</div>
      <div style="float: right; margin-top: 8px">
        <v-menu :close-on-content-click="false" :nudge-width="200" offset-y transition="slide-y-transition" left fixed style="position: absolute; right: 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="indigo" icon v-bind="attrs" v-on="on">
              <v-icon small 
                :color="activeFilters[header.value] && activeFilters[header.value].length < filters[header.value].length ? 'red' : 'default'">
                mdi-filter-variant
              </v-icon>
            </v-btn>
          </template>
          <v-list flat dense class="pa-0">
            <v-list-item-group multiple v-model="activeFilters[header.value]" class="py-2">
              <template v-for="(item, i) in filters[header.value]">
                <v-list-item :key="`${item}`" :value="item" :ripple="false">
                  <template v-slot:default="{ active, toggle }">
                    <v-list-item-action>
                      <v-checkbox :input-value="active" :true-value="item"
                        color="primary" :ripple="false" dense></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content> 
                      <v-list-item-title v-text="item"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
            <v-divider></v-divider>
            <v-row no-gutters>
              <v-col cols="6">
                <v-btn text block @click="toggleAll(header.value)" color="success">Toggle all</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn text block @click="clearAll(header.value)" color="warning">Clear all</v-btn>
              </v-col>
            </v-row>
          </v-list>
        </v-menu>
      </div>
    </template>
    <template v-slot:top>
      <v-row>
        <v-col
          class="col-12"
        >
          <v-text-field
            v-model="search"
            label="Search"
            class="mx-4"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:item.contract_name="{ item }">
      <router-link
        :to="`/contracts/${item.contract_id}`"
        class="text-decoration-none"
      >
        {{ item.contract_name }}
      </router-link>
    </template>
    <template
      v-slot:item.last_modified_date="{ item }"
    >
      {{ getUTCString(item.last_modified_date) }}
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: 'PausedAlertsTable',
    props: {
      contracts: Array,
    },
    data () {
      return {
        headers: [
          { value: 'contract_name', text: 'Customer', width: '20%'},
          { value: 'contract_number', text: 'Contract' },
          {
            value: 'status',
            text: 'Status',
            sortable: true,
            filter: value => {
              return this.activeFilters.status ? this.activeFilters.status.includes(value) : true
            },
          },
          { value: 'last_modified_by_user.user_name', text: 'User' },
          { value: 'last_modified_date', text: 'Paused' },
        ],
        options: {
          itemsPerPage: -1,
          sortBy: ['status'],
        },
        search: '',
        filters: { 'status': [] },
        activeFilters: { 'status': [ 'Live Status' ]},
      }
    },
    mounted () {
      this.initFilters()
    },
    methods: {
      getUTCString: function (datetime) {
        const d = new Date(datetime)
        return d.toUTCString()
      },
      initFilters() {
        for (var col in this.filters) {
          this.filters[col] = this.contracts.map((d) => { return d[col] }).filter(
            (value, index, self) => { return self.indexOf(value) === index }
          )
        }
      },
      toggleAll (col) {
        this.activeFilters[col] = this.contracts.map((d) => { return d[col] }).filter(
          (value, index, self) => { return self.indexOf(value) === index }
        )
      },
      clearAll (col) {
        this.activeFilters[col] = []
      },
    },
  }
</script>
